webpackJsonp([106077160987319],{

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/profile_phamvanlam-com-co-dien.be33c8b1.jpg";

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _profile_phamvanlamComCoDien = __webpack_require__(687);
	
	var _profile_phamvanlamComCoDien2 = _interopRequireDefault(_profile_phamvanlamComCoDien);
	
	var _widgetContainer = __webpack_require__(17);
	
	var _widgetContainer2 = _interopRequireDefault(_widgetContainer);
	
	var _lazyImage = __webpack_require__(57);
	
	var _lazyImage2 = _interopRequireDefault(_lazyImage);
	
	var _placeHolder = __webpack_require__(69);
	
	var _placeHolder2 = _interopRequireDefault(_placeHolder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var seoTitle = "Gi\u1EDBi thi\u1EC7u - " + data.site.siteMetadata.title;
	  var url = data.site.siteMetadata.siteUrl + "/gioi-thieu/";
	
	  return Glamor.createElement(
	    "article",
	    null,
	    Glamor.createElement(_reactHelmet2.default, {
	      title: seoTitle,
	      meta: [{ name: 'description', content: "" + data.site.siteMetadata.description }, { name: 'keywords', content: "" + data.site.siteMetadata.keywords }],
	      link: [{ rel: "canonical", href: "" + url }]
	    }),
	    Glamor.createElement(
	      "h1",
	      null,
	      "Gi\u1EDBi thi\u1EC7u"
	    ),
	    Glamor.createElement(
	      _widgetContainer2.default,
	      null,
	      Glamor.createElement(
	        "p",
	        null,
	        "Xin ch\xE0o c\xE1c b\u1EA1n! T\xF4i l\xE0 Ph\u1EA1m V\u0103n L\xE2m, c\u1EF1u sinh vi\xEAn \u0110\u1EA1i h\u1ECDc B\xE1ch Khoa H\xE0 N\u1ED9i chuy\xEAn ng\xE0nh \u0110i\u1EC7n t\u1EED \u2013 Vi\u1EC5n th\xF4ng. Hi\u1EC7n t\u1EA1i, t\xF4i \u0111ang l\xE0m vi\u1EC7c t\u1EA1i SVMC \u2013 trung t\xE2m nghi\xEAn c\u1EE9u v\xE0 ph\xE1t tri\u1EC3n \u0111i\u1EC7n tho\u1EA1i di \u0111\u1ED9ng Samsung t\u1EA1i Vi\u1EC7t Nam."
	      ),
	      Glamor.createElement(
	        "div",
	        { style: { display: "flex", justifyContent: "center" } },
	        Glamor.createElement(_lazyImage2.default, {
	          placeHolder: _placeHolder2.default,
	          src: _profile_phamvanlamComCoDien2.default,
	          width: "252",
	          height: "auto",
	          effect: "opacity",
	          alt: "lam pham profile image",
	          keepRatio: true
	        })
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "Blog n\xE0y \u0111\u01B0\u1EE3c l\u1EADp n\xEAn v\u1EDBi m\u1EE5c \u0111\xEDch chia s\u1EBB nh\u1EEFng ki\u1EBFn th\u1EE9c v\xE0 kinh nghi\u1EC7m c\u1EE7a b\u1EA3n th\xE2n v\u1EC1 c\xE1c c\xE1c ph\u1EA7n m\u1EC1m mi\u1EC5n ph\xED, m\xE3 ngu\u1ED3n m\u1EDF,... t\u1ED1t nh\u1EA5t"
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "V\xEC nh\u01B0 c\xE1c b\u1EA1n \u0111\xE3 bi\u1EBFt, ti\u1EC1n mua b\u1EA3n quy\u1EC1n s\u1EED d\u1EE5ng c\xE1c ph\u1EA7n m\u1EC1m ch\u1EC9nh s\u1EEDa \u1EA3nh nh\u01B0 Adobe Photoshop, ph\u1EA7n m\u1EC1m ch\u1EC9nh s\u1EEDa video nh\u01B0 Adobe Premiere hay ph\u1EA7n m\u1EC1m v\u0103n ph\xF2ng Microsoft Office,\u2026 l\xE0 kh\xF4ng h\u1EC1 nh\u1ECF. V\xEC v\u1EADy, trong qu\xE1 tr\xECnh h\u1ECDc t\u1EADp v\xE0 l\xE0m vi\u1EC7c, t\xF4i \u0111\xE3 t\xECm hi\u1EC3u v\xE0 s\u1EED d\u1EE5ng m\u1ED9t s\u1ED1 ph\u1EA7n m\u1EC1m m\xE3 ngu\u1ED3n m\u1EDF thay th\u1EBF nh\u01B0 GIMP (ch\u1EC9nh s\u1EEDa h\xECnh \u1EA3nh), KDEnlive (ch\u1EC9nh s\u1EEDa video), Libre Office (ph\u1EA7n m\u1EC1m v\u0103n ph\xF2ng),\u2026"
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "T\xF4i nh\u1EADn th\u1EA5y r\u1EB1ng nh\u1EEFng ph\u1EA7n m\u1EC1m m\xE3 ngu\u1ED3n m\u1EDF n\xE0y ho\xE0n to\xE0n mi\u1EC5n ph\xED m\xE0 kh\xF4ng h\u1EC1 thua k\xE9m g\xEC c\xE1c ph\u1EA7n m\u1EC1m chuy\xEAn nghi\u1EC7p. Do \u0111\xF3, t\xF4i l\u1EADp n\xEAn trang n\xE0y v\u1EDBi m\u1EE5c \u0111\xEDch chia s\u1EBB nh\u1EEFng ki\u1EBFn th\u1EE9c v\xE0 kinh nghi\u1EC7m c\u1EE7a b\u1EA3n th\xE2n v\u1EC1 c\xE1ch s\u1EED d\u1EE5ng c\xE1c ph\u1EA7n m\u1EC1m m\xE3 ngu\u1ED3n m\u1EDF nh\u01B0 GIMP, KDEnlive, Libre Office,\u2026 v\u1EDBi c\xE1c b\u1EA1n."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "R\u1EA5t mong nh\u1EADn \u0111\u01B0\u1EE3c s\u1EF1 \u1EE7ng h\u1ED9 v\xE0 \u0111\xF3ng g\xF3p \xFD ki\u1EBFn c\u1EE7a c\xE1c b\u1EA1n \u0111\u1EC3 trang web ng\xE0y c\xE0ng ho\xE0n thi\u1EC7n h\u01A1n. Qua \u0111\xF3, t\xF4i c\xF3 th\xEAm nhi\u1EC1u \u0111\u1ED9ng l\u1EF1c \u0111\u1EC3 ph\xE1t tri\u1EC3n trang n\xE0y."
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gioi-thieu-js-b7f8728c758e932d218b.js